import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Label = ({ children, className = "", testId }) => (
  <p
    data-testid={testId}
    className={`uppercase tracking-luxe text-[11px] font-medium text-brand-gold ${className}`}
  >
    {children}
  </p>
);

export const GoldLink = ({ to, href, children, testId, className = "" }) => {
  const cls = `inline-flex items-center justify-center gap-3 bg-brand-gold text-brand-ink px-8 py-4 text-sm font-semibold tracking-wide uppercase transition-all duration-300 hover:bg-brand-gold-hover hover:shadow-[0_8px_32px_rgba(201,169,110,0.35)] hover:-translate-y-0.5 ${className}`;
  if (href)
    return (
      <a data-testid={testId} href={href} target="_blank" rel="noopener noreferrer" className={cls}>
        {children}
      </a>
    );
  return (
    <Link data-testid={testId} to={to} className={cls}>
      {children}
    </Link>
  );
};

export const OutlineLink = ({ to, children, testId, className = "" }) => (
  <Link
    data-testid={testId}
    to={to}
    className={`inline-flex items-center justify-center gap-3 border border-white/25 text-white px-8 py-4 text-sm font-medium tracking-wide uppercase transition-colors duration-300 hover:border-brand-gold hover:text-brand-gold ${className}`}
  >
    {children}
  </Link>
);

export const Diamond = ({ className = "" }) => (
  <span className={`text-brand-gold text-[10px] ${className}`} aria-hidden="true">
    ◆
  </span>
);
